import Content from "uxp-documentation/src/pages/uxp-api/reference-html/Hierarchy/footer";
import * as React from 'react';
export default {
  Content,
  React
};